import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Terms.module.css";

export const Terms = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine the title based on the current path
  let type = "Terms";
  if (location.pathname === "/privacy-policy") {
    type = "Privacy Policy";
  } else if (location.pathname === "/terms") {
    type = "Terms of Service";
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.row}>
        <h1 className={styles.title}>{type}</h1>
        <button className={styles.close} onClick={() => navigate(-1)}>
          &#x2715;
        </button>
      </div>

      <p className={styles.sectionText}>Last updated June 28th, 2025</p>

      <h2 className={styles.sectionTitle}>1. INTRODUCTION</h2>
      <p className={styles.sectionText}>
        Welcome to Snuff, operated by Snuff LLC ("Company," "we," "us," or
        "our"). Your privacy and health journey are important to us. This {type}{" "}
        explains how we collect, use, and protect your information when you use
        our mobile application, website, and any related services (collectively,
        the "Services").
      </p>
      <p className={styles.sectionText}>
        By using Snuff, you agree to the terms of this {type}. If you do not
        agree, please refrain from using our Services.
      </p>

      <h2 className={styles.sectionTitle}>2. INFORMATION WE COLLECT</h2>
      <p className={styles.sectionText}>
        At Snuff, we respect your privacy and are committed to ensuring your
        data is protected. Here's what we collect:
      </p>
      <p className={styles.sectionText}>
        • Personal Health Data: Information about your vaping habits, quit
        journey progress, cravings, triggers, and health goals to provide
        personalized support.
      </p>
      <p className={styles.sectionText}>
        • Usage Data: Information about how you interact with our app, including
        meditation sessions completed, panic button usage, and feature
        engagement.
      </p>
      <p className={styles.sectionText}>
        • Analytics Data: With your explicit consent, we may collect anonymized
        usage data (e.g., app performance metrics) to improve our Services.
      </p>
      <p className={styles.sectionText}>
        What We Don't Collect: We do not collect or store any payment details.
        All payment transactions are securely handled by third-party payment
        processors.
      </p>

      <h2 className={styles.sectionTitle}>3. HOW WE USE YOUR INFORMATION</h2>
      <p className={styles.sectionText}>
        We use the information you provide solely for the following purposes:
      </p>
      <p className={styles.sectionText}>
        • To provide personalized quit vaping support and track your progress
        through your journey to becoming vape-free.
      </p>
      <p className={styles.sectionText}>
        • To deliver relevant content, meditation sessions, and coping
        strategies based on your specific needs and triggers.
      </p>
      <p className={styles.sectionText}>
        • To analyze anonymized usage trends and ensure the stability and
        effectiveness of our Services.
      </p>
      <p className={styles.sectionText}>
        • To provide emergency support features like the panic button when you
        experience intense cravings.
      </p>

      <h2 className={styles.sectionTitle}>4. MEDICAL DISCLAIMER</h2>
      <p className={styles.sectionText}>
        Snuff is designed to support your quit vaping journey but is not a
        substitute for professional medical advice, diagnosis, or treatment. The
        app provides educational content, meditation sessions, and coping
        strategies to help you quit vaping.
      </p>
      <p className={styles.sectionText}>
        By using our Services, you understand and agree that Snuff LLC is not
        liable for any health outcomes related to your quit vaping journey.
        Users should consult with healthcare professionals for medical advice
        and may need additional support such as nicotine replacement therapy or
        counseling. If you experience severe withdrawal symptoms or health
        concerns, please seek immediate medical attention.
      </p>

      <h2 className={styles.sectionTitle}>5. USER RESPONSIBILITIES</h2>
      <p className={styles.sectionText}>By using Snuff, you agree to:</p>
      <p className={styles.sectionText}>
        • Provide accurate information about your vaping habits and health
        status.
      </p>
      <p className={styles.sectionText}>
        • Use the app as a supplement to, not replacement for, professional
        medical advice when needed.
      </p>
      <p className={styles.sectionText}>
        • Not share your account credentials with others.
      </p>
      <p className={styles.sectionText}>
        • Use the app responsibly and not rely solely on it for medical
        decisions.
      </p>
    </div>
  );
};

export default Terms;
